/* eslint-disable max-classes-per-file */
export class ExecutionError extends Error {
  constructor(messages, caption = '') {
    const strs = messages.reduce((R, e) => `${R}<li>${e}</li>`, '');
    super(`<div class="fw-bold">${caption}</div><ul>${strs}</ul>`);
    this.name = 'ExecutionError';
  }
}

export class SubscriptionError extends Error {
  constructor(messages, caption = '') {
    const strs = messages.reduce((R, e) => `${R}<li>${e}</li>`, '');
    super(`<div class="fw-bold">${caption}</div><ul>${strs}</ul>`);
    this.name = 'SubscriptionError';
  }
}
